import { withService } from '@services/withService';
import { withData } from '@services/withData';
import { withAppContext } from '@contexts/app/hoc/withAppContext';
import { withAppSetting } from '@contexts/appSetting/hoc/withAppSetting';
import { withMemberContext } from '@contexts/member/hoc/withMemberContext';
import { withNotification } from '@components/Notification/withNotification';
import { withSDKSettingsContext } from '@contexts/sdkSettings/hoc/withSDKSettingsContext';
import { WithDeviceIntelligence } from '@contexts/deviceIntelligence/hoc/withDeviceIntelligence';
import { WithSigninNavigation } from '@contexts/signinNavigation/hoc/withSigninNavigation';
import { WithFingerprint } from '@contexts/deviceIntelligence/hoc/withFingerprint';
import { WithWalletNavigation } from '@contexts/walletNavigation/hoc/withWalletNavigation';
import { WithTermsOfConsent } from '@contexts/termsOfConsent/hoc/withTermsOfConsent';

export const withDependencies = <TProps>(Component: React.FC<TProps>) => {
    const ComponentWithDependencies = withAppContext(
        withAppSetting(
            withMemberContext(
                withData(
                    WithFingerprint(
                        WithDeviceIntelligence(
                            withService(
                                withSDKSettingsContext(
                                    WithSigninNavigation(
                                        WithTermsOfConsent(WithWalletNavigation(withNotification(Component)))
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );

    ComponentWithDependencies.displayName = `${Component.displayName || 'Component'}WithDependencies`;

    return ComponentWithDependencies;
};
